import { render } from "./ModalInformativoSaibaMais.vue?vue&type=template&id=58e2d80e&scoped=true"
import script from "./ModalInformativoSaibaMais.vue?vue&type=script&lang=js"
export * from "./ModalInformativoSaibaMais.vue?vue&type=script&lang=js"

import "./ModalInformativoSaibaMais.vue?vue&type=style&index=0&id=58e2d80e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58e2d80e"]])

export default __exports__